<form #form="ngForm" autocomplete="off">
    <div class="responsive-grid">
        <div class="row">
            <mat-form-field>
                <mat-label>First Pay Date:</mat-label>
                <input
                    matInput
                    required
                    k
                    name="firstPayDate"
                    #firstPayDateInput="ngModel"
                    [(ngModel)]="firstPayDate"
                    [matDatepicker]="picker"
                />
                <mat-datepicker-toggle matSuffix [for]="picker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="firstPayDateInput.invalid">{{ firstPayDateInput.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Days in Arrears:</mat-label>
                <input
                    matInput
                    required
                    type="number"
                    name="daysInArrears"
                    #daysInArrearsInput="ngModel"
                    [(ngModel)]="daysInArrears"
                />
                <mat-error *ngIf="daysInArrearsInput.invalid">{{ daysInArrearsInput.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field>
                <mat-label appRemoveAriaOwns>Frequency</mat-label>
                <mat-select required [(ngModel)]="frequency" #frequencyInput="ngModel" name="frequency">
                    <mat-option value="weekly">Weekly</mat-option>
                    <mat-option value="biweekly">Biweekly</mat-option>
                    <mat-option value="semimonthly">Semimonthly</mat-option>
                    <mat-option value="monthly">Monthly</mat-option>
                </mat-select>
                <mat-error *ngIf="frequencyInput.invalid">{{ frequencyInput.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="frequency === 'weekly' || frequency === 'biweekly'">
                <mat-label appRemoveAriaOwns>Day of the Week</mat-label>
                <mat-select required name="dayOfWeek" #dayOfTheWeekInput="ngModel" [(ngModel)]="dayOfTheWeek">
                    <mat-option value="monday">Monday</mat-option>
                    <mat-option value="tuesday">Tuesday</mat-option>
                    <mat-option value="wednesday">Wednesday</mat-option>
                    <mat-option value="thursday">Thursday</mat-option>
                    <mat-option value="friday">Friday</mat-option>
                </mat-select>
                <mat-error *ngIf="dayOfTheWeekInput.invalid">{{ dayOfTheWeekInput.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <ng-container *ngIf="frequency === 'monthly' || frequency === 'semimonthly'">
            <div class="row">
                <mat-form-field>
                    <mat-label>First Day Of Month</mat-label>
                    <input
                        matInput
                        type="number"
                        required
                        name="firstDayOfTheMonth"
                        #dayOfTheMonthInput="ngModel"
                        [(ngModel)]="firstDayOfTheMonth"
                    />
                    <mat-error *ngIf="dayOfTheMonthInput.invalid">
                        {{ dayOfTheMonthInput.errors | formErrors }}</mat-error
                    >
                </mat-form-field>
                <mat-form-field *ngIf="frequency === 'semimonthly'">
                    <mat-label>Second Day Of Month</mat-label>
                    <input
                        matInput
                        type="number"
                        required
                        name="secondDayOfTheMonth"
                        #secondDayOfTheMonthInput="ngModel"
                        [(ngModel)]="secondDayOfTheMonth"
                    />
                    <mat-error *ngIf="secondDayOfTheMonthInput.invalid">{{
                        secondDayOfTheMonthInput.errors | formErrors
                    }}</mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <h5 class="text-align-center">For the last day of the month, set "-1" as the value.</h5>
            </div>
        </ng-container>
    </div>
</form>
